import { Header } from '@/components/ui/header';
import { Footer } from '@/components/ui/footer';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export const PublicLayout = () => {
  return (
    <>
      <Header />
      <Box component="main">
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default PublicLayout;